import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../../const";
import _ from 'lodash';
import { Service } from "../../../../../service/service"
import { unAuthorized } from '../../../../../auth/Auth.ducks'
import { fetchKids } from "../../../Kids-list.ducks";

// Message actions

export const POST_MESSAGE_PENDING = "POST_MESSAGE_PENDING";
export const POST_MESSAGE_REJECTED = "POST_MESSAGE_REJECTED";
export const POST_MESSAGE_FULFILLED = "POST_MESSAGE_FULFILLED";

export const GET_MESSAGE_PENDING = "GET_MESSAGE_PENDING";
export const GET_MESSAGE_REJECTED = "GET_MESSAGE_REJECTED";
export const GET_MESSAGE_FULFILLED = "GET_MESSAGE_FULFILLED";
const loading = (state = {}, { type }) => {
  switch (type) {
    case POST_MESSAGE_PENDING:
    case GET_MESSAGE_PENDING:

      return true;
    case POST_MESSAGE_REJECTED:
    case POST_MESSAGE_FULFILLED:
    case GET_MESSAGE_REJECTED:
    case GET_MESSAGE_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_MESSAGE_PENDING:
    case POST_MESSAGE_FULFILLED:
    case GET_MESSAGE_PENDING:
    case GET_MESSAGE_FULFILLED:
      return null;
    case POST_MESSAGE_REJECTED:
    case GET_MESSAGE_REJECTED:

      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_MESSAGE_FULFILLED:
    case GET_MESSAGE_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;

    case POST_MESSAGE_PENDING:
    case GET_MESSAGE_PENDING:
      return null;
    case POST_MESSAGE_REJECTED:
    case GET_MESSAGE_REJECTED:
      return null;

    default:
      return state;
  }
};

// Message reducer
export default combineReducers({ loading, error, data });

export const postMessageMulti = (tok, data) => {
  return (dispatch) => {
    const response = Service.post(`${API}api/enfant/creche/enfants/messages`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: POST_MESSAGE_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: POST_MESSAGE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const postMessageSimple = (tok, id, data) => {
  return (dispatch) => {
    const response = Service.post(`${API}api/enfant/creche/enfants/${id}/messages`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: POST_MESSAGE_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: POST_MESSAGE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}